import * as Yup from "yup";

export const table = {
  primaryData: [
    {
        title: "ID",
        value: "id",
        type: "configue",
    },
    {
        title: "Vendor Name",
        value: "vendorName",
        type: "configue",
    },
    {
        title: "Product Name",
        value: "productName",
        type: "configue",
    },
    {
        title: "Associated Domain Name",
        value: "associatedDomainName",
        type: "configue",
    },
    {
        title: "Created At",
        value: "createdAt",
        type: "configue",
    },
    {
        title: "Updated At",
        value: "updatedAt",
        type: "configue",
        name: "updatedAt"
    },
    {
        title: "Created By",
        value: "createdByName",
        type: "configue"
    },
    {
        title: "Updated By",
        value: "updatedByName",
        type: "configue",
        name: "updatedByName"
    }
    
  ],
  secondaryData: [],
};

export type vendorAccount = {
      id: string,
      vendorId: string,
      vendorName: string,
      productId : string,
      productName: string,
      associatedDomainName: string,
      vendorMetadata: string,
      createdAt: string,
      updatedAt: string,
      createdById: string,
      updatedById: string,
      createdByName: string,
      updatedByName: string, 
};

export const vendorAccountInitialValues: vendorAccount= {
      id:"",
      vendorId : "",
      vendorName: "",
      productId: "",
      productName: "",
      associatedDomainName: "",
      vendorMetadata: "",
      createdAt: "",
      updatedAt: "",
      createdById: "",
      updatedById: "",
      createdByName: "",
      updatedByName: "",
};

export const vendorAccountMandatoryFields = [{ id: "associatedDomainName" }];

export const vendorAccountValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
});

export const vendorAccountProperties = [
  {
    id: "id",
    type: "text",
    label: `ID`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "vendorName",
    type: "text",
    label: `Vendor Account Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "ProductName",
    type: "text",
    label: `Description`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "associatedDomainName",
    type: "text",
    label: `Capabilities`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "createdAt",
    type: "date-picker",
    label: `Created At`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updatedAt",
    type: "date-picker",
    label: `Updated At`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "createdById",
    type: "text",
    label: `Created By Id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updatedById",
    type: "text",
    label: `Updated By Id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "createdByName",
    type: "text",
    label: `Created By Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updatedByName",
    type: "text",
    label: `Updated By Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  }
];